import type { APIWithFields, SWRConfigInterface } from "@gik/core/api/BaseAPIConfig";
import { wpApi } from "@gik/core/api/ky/wpApi";
import { useWPApi } from "@gik/core/api/swr/useWPApi";
import type WordpressPost from "@gik/core/models/wordpress/WordpressPost";
import PostsUrlBuilder from "./PostsUrlBuilder";

const path = "posts";
export interface PostsLatestParams extends APIWithFields {}

function getParams(params?: PostsLatestParams) {
	// prettier-ignore
	return new PostsUrlBuilder()
		.withPerPage(3)
		.withFields(params?.fields)
		.orderedByDate().params;
}

export function getLatestPosts(
	params?: PostsLatestParams,
): Promise<WordpressPost[]> {
	return wpApi
		.get(path, {
			searchParams: getParams(params),
		})
		.json<WordpressPost[]>();
}

export function useLatestPosts(
	params?: PostsLatestParams,
	config?: SWRConfigInterface,
) {
	return useWPApi<WordpressPost[]>(path, getParams(params), config);
}
